const poojaData = {
  EN: [
    {
      id: 1,
      name: "Pooja",
      icon: "🙏",
      price: "₹5",
      desc: "Basic daily pooja performed at the temple.",
      image: "/assets/dharshana.png"
    },
    {
      id: 2,
      name: "Garland Offering (Mala)",
      icon: "🌸",
      price: "₹5",
      desc: "Flower garland offering to the deity.",
      image: "/assets/11.jpg"
    },
    {
      id: 3,
      name: "Pushpanjali",
      icon: "🌸",
      price: "₹8",
      desc: "Offering of flowers with prayers.",
      image: "/assets/20.jpg"
    },
    {
      id: 4,
      name: "Ghee Lamp (Ney Vilakku)",
      icon: "🪔",
      price: "₹10",
      desc: "Lighting a lamp using ghee.",
      image: "/assets/16.jpg"
    },
    {
      id: 5,
      name: "Garland Pooja (Malayidal)",
      icon: "🌼",
      price: "₹10",
      desc: "Ritual offering of garlands with prayers.",
      image: "/assets/12.jpg"
    },
    {
      id: 6,
      name: "Offering Bundle (Kettunira)",
      icon: "🎁",
      price: "₹10",
      desc: "Symbolic offering tied and presented to the deity.",
      image: "/assets/9.jpg"
    },
    {
      id: 7,
      name: "Raktha Pushpanjali",
      icon: "🌺",
      price: "₹10",
      desc: "Special red flower offering for divine blessings.",
      image: "/assets/21.jpg"
    },
    {
      id: 8,
      name: "Firecracker Offering (Kathana)",
      icon: "🎆",
      price: "₹10",
      desc: "Traditional firecracker offering in temple rituals.",
      image: "/assets/26.jpg"
    },
    {
      id: 9,
      name: "First Rice Feeding (Choroonu)",
      icon: "👶",
      price: "₹25",
      desc: "Sacred ceremony marking a child's first intake of solid food.",
      image: "/assets/3.webp"
    },
    {
      id: 10,
      name: "Thrimadhuram",
      icon: "🍬",
      price: "₹25",
      desc: "Offering made from three sweet ingredients.",
      image: "/assets/23.jpg"
    },
    {
      id: 11,
      name: "Palm Jaggery Payasam (Panapayasam)",
      icon: "🍯",
      price: "₹30",
      desc: "Traditional sweet made with palm jaggery.",
      image: "/assets/19.jpg"
    },
    {
      id: 12,
      name: "Sooktha Pushpanjali",
      icon: "📿",
      price: "₹40",
      desc: "Pushpanjali performed with Vedic hymns.",
      image: "/assets/22.jpg"
    },
    {
      id: 13,
      name: "Thulabharam Slip (Thulabaram Seetu)",
      icon: "⚖️",
      price: "₹50",
      desc: "Token slip for Thulabharam — offering equal to the devotee's weight.",
      image: "/assets/25.jpg"
    },
    {
      id: 14,
      name: "Adiya Chanth",
      icon: "📿",
      price: "₹50",
      desc: "Traditional chanting ritual invoking divine energy and positivity.",
      image: "/assets/2.jpg"
    },
    {
      id: 15,
      name: "Ghee Payasam (Ney Payasam)",
      icon: "🥣",
      price: "₹50",
      desc: "Sweet offering prepared with ghee.",
      image: "/assets/15.jpg"
    },
    {
      id: 16,
      name: "Mixed Payasam (Koottupayasam)",
      icon: "🍮",
      price: "₹50",
      desc: "Combination of different payasams offered to the deity.",
      image: "/assets/10.jpg"
    },
    {
      id: 17,
      name: "Thada",
      icon: "🛕",
      price: "₹60",
      desc: "Special ritual offering at the temple.",
      image: "/assets/17.jpg"
    },
    {
      id: 18,
      name: "Milk Payasam (Palpayasam)",
      icon: "🥛",
      price: "₹60",
      desc: "Sweet offering made with milk and rice.",
      image: "/assets/188.jpg"
    },
    {
      id: 19,
      name: "Jaggery Payasam (Kadumadhura Payasam)",
      icon: "🍯",
      price: "₹70",
      desc: "Sweet offering made with jaggery and rice.",
      image: "/assets/8.jpg"
    },
    {
      id: 20,
      name: "Ganapathy Homam",
      icon: "🔥",
      price: "₹70",
      desc: "Fire ritual dedicated to Lord Ganesha for removing obstacles.",
      image: "/assets/7.jpg"
    },
    {
      id: 21,
      name: "Bhagavathy Seva",
      icon: "🪔",
      price: "₹100",
      desc: "Special offering performed to Goddess Bhagavathy for blessings and protection.",
      image: "/assets/dharshana.png"
    },
    {
      id: 22,
      name: "Lamp Tower Lighting (Deepasthambham)",
      icon: "🔥",
      price: "₹200",
      desc: "Lighting the sacred lamp pillar in the temple.",
      image: "/assets/fire.jpg"
    },
    {
      id: 23,
      name: "Three-time Daily Pooja (Thrikala Pooja)",
      icon: "🛕",
      price: "₹251",
      desc: "Pooja performed three times in a day.",
      image: "/assets/24.jpg"
    },
    {
      id: 24,
      name: "Navarathri Lamp Ritual",
      icon: "✨",
      price: "₹300",
      desc: "Special lamp offering during Navarathri festival.",
      image: "/assets/14.jpg"
    },
    {
      id: 25,
      name: "Mandala Lamp Ritual",
      icon: "🪔",
      price: "₹300",
      desc: "Lamp lighting ritual during Mandala season.",
      image: "/assets/13.jpg"
    },
    {
      id: 26,
      name: "Lamp Offering (Chuttuvilakku)",
      icon: "🪔",
      price: "₹401",
      desc: "Lighting rows of lamps around the temple as an offering.",
      image: "/assets/4.jpg"
    },
    {
      id: 27,
      name: "Lamp Garland Offering (Niramala Chuttuvilakku)",
      icon: "✨",
      price: "₹1000",
      desc: "Decorative lighting of lamps forming a divine illumination around the temple.",
      image: "/assets/deepaam.jpg"
    },
    {
      id: 28,
      name: "Chanthabishekam",
      icon: "🪔",
      price: "₹1250",
      desc: "Sacred abhishekam ritual performed with sandalwood paste.",
      image: "/assets/dharshana.png"
    },
    {
      id: 29,
      name: "Full Day Pooja (Oru Divasathe Pooja)",
      icon: "🙏",
      price: "₹1251",
      desc: "Complete day-long pooja performed in the devotee's name.",
      image: "/assets/17.jpg"
    }
  ],

  TA: [
    {
      id: 1,
      name: "பூஜை",
      icon: "🙏",
      price: "₹5",
      desc: "கோயிலில் தினமும் செய்யப்படும் அடிப்படை பூஜை.",
      image: "/assets/dharshana.png"
    },
    {
      id: 2,
      name: "மாலை",
      icon: "🌸",
      price: "₹5",
      desc: "மலர் மாலை சமர்ப்பிப்பு.",
      image: "/assets/11.jpg"
    },
    {
      id: 3,
      name: "புஷ்பாஞ்சலி",
      icon: "🌸",
      price: "₹8",
      desc: "மலர்களால் செய்யப்படும் பிரார்த்தனை.",
      image: "/assets/20.jpg"
    },
    {
      id: 4,
      name: "நெய் விளக்கு",
      icon: "🪔",
      price: "₹10",
      desc: "நெய்யில் விளக்கேற்றுதல்.",
      image: "/assets/16.jpg"
    },
    {
      id: 5,
      name: "மாலையிடல்",
      icon: "🌼",
      price: "₹10",
      desc: "மாலையுடன் செய்யப்படும் பூஜை.",
      image: "/assets/12.jpg"
    },
    {
      id: 6,
      name: "கெட்டுநிறை",
      icon: "🎁",
      price: "₹10",
      desc: "கட்டிப்போட்டு தெய்வத்திற்கு சமர்ப்பிக்கும் குறியீட்டு காணிக்கை.",
      image: "/assets/9.jpg"
    },
    {
      id: 7,
      name: "ரக்த புஷ்பாஞ்சலி",
      icon: "🌺",
      price: "₹10",
      desc: "சிவப்பு மலர்களால் செய்யப்படும் சிறப்பு வழிபாடு.",
      image: "/assets/21.jpg"
    },
    {
      id: 8,
      name: "கதினா (1 எண்ணிக்கை)",
      icon: "🎆",
      price: "₹10",
      desc: "பாரம்பரிய பட்டாசு காணிக்கை.",
      image: "/assets/26.jpg"
    },
    {
      id: 9,
      name: "சோறூண் (முதல் அன்னபிராசனம்)",
      icon: "👶",
      price: "₹25",
      desc: "குழந்தையின் முதல் உறைந்த உணவு உட்கொள்ளும் புனித சடங்கு.",
      image: "/assets/3.webp"
    },
    {
      id: 10,
      name: "திரிமதுரம்",
      icon: "🍬",
      price: "₹25",
      desc: "மூன்று இனிப்புகளால் தயாரிக்கப்படும் நைவேத்யம்.",
      image: "/assets/23.jpg"
    },
    {
      id: 11,
      name: "பனை பாயாசம்",
      icon: "🍯",
      price: "₹30",
      desc: "பனை கருப்பட்டியால் தயாரிக்கப்படும் பாரம்பரிய இனிப்பு.",
      image: "/assets/19.jpg"
    },
    {
      id: 12,
      name: "சூக்த புஷ்பாஞ்சலி",
      icon: "📿",
      price: "₹40",
      desc: "வேத மந்திரங்களுடன் செய்யப்படும் புஷ்பாஞ்சலி.",
      image: "/assets/22.jpg"
    },
    {
      id: 13,
      name: "துலாபாரம் சீட்டு",
      icon: "⚖️",
      price: "₹50",
      desc: "பக்தரின் எடைக்கு சமமாக காணிக்கை செலுத்துவதற்கான அடையாள சீட்டு.",
      image: "/assets/25.jpg"
    },
    {
      id: 14,
      name: "ஆதிய சாந்த்",
      icon: "📿",
      price: "₹50",
      desc: "தெய்வீக சக்தி மற்றும் நேர்மறை ஆற்றலை அழைக்கும் பாரம்பரிய ஜெப வழிபாடு.",
      image: "/assets/2.jpg"
    },
    {
      id: 15,
      name: "நெய் பாயாசம்",
      icon: "🥣",
      price: "₹50",
      desc: "நெய்யால் தயாரிக்கப்படும் இனிப்பு நைவேத்யம்.",
      image: "/assets/15.jpg"
    },
    {
      id: 16,
      name: "கூட்டு பாயாசம்",
      icon: "🍮",
      price: "₹50",
      desc: "பல வகை பாயாசங்களின் கலவை நைவேத்யம்.",
      image: "/assets/10.jpg"
    },
    {
      id: 17,
      name: "தட",
      icon: "🛕",
      price: "₹60",
      desc: "கோயிலில் செய்யப்படும் சிறப்பு வழிபாடு.",
      image: "/assets/17.jpg"
    },
    {
      id: 18,
      name: "பால் பாயாசம்",
      icon: "🥛",
      price: "₹60",
      desc: "பால் மற்றும் அரிசியால் தயாரிக்கப்படும் இனிப்பு.",
      image: "/assets/188.jpg"
    },
    {
      id: 19,
      name: "கடும் பாயாசம்",
      icon: "🍯",
      price: "₹70",
      desc: "கருப்பட்டி மற்றும் அரிசியால் தயாரிக்கப்படும் இனிப்பு நைவேத்யம்.",
      image: "/assets/8.jpg"
    },
    {
      id: 20,
      name: "கணபதி ஹோமம்",
      icon: "🔥",
      price: "₹70",
      desc: "விநாயகருக்கான ஹோமம், தடைகளை நீக்குவதற்காக செய்யப்படும்.",
      image: "/assets/7.jpg"
    },
    {
      id: 21,
      name: "பகவதி சேவை",
      icon: "🪔",
      price: "₹100",
      desc: "அம்மன் பகவதிக்கு ஆசீர்வாதம் மற்றும் பாதுகாப்பிற்காக செய்யப்படும் சிறப்பு வழிபாடு.",
      image: "/assets/dharshana.png"
    },
    {
      id: 22,
      name: "தீபஸ்தம்பம் ஏற்றுதல்",
      icon: "🔥",
      price: "₹200",
      desc: "கோயிலின் தீபஸ்தம்பத்தில் விளக்கேற்றும் வழிபாடு.",
      image: "/assets/fire.jpg"
    },
    {
      id: 23,
      name: "மூன்று கால பூஜை",
      icon: "🛕",
      price: "₹251",
      desc: "ஒரு நாளில் மூன்று முறை செய்யப்படும் பூஜை.",
      image: "/assets/24.jpg"
    },
    {
      id: 24,
      name: "நவராத்திரி தீப வழிபாடு",
      icon: "✨",
      price: "₹300",
      desc: "நவராத்திரி காலத்தில் செய்யப்படும் தீப வழிபாடு.",
      image: "/assets/14.jpg"
    },
    {
      id: 25,
      name: "மண்டல தீப வழிபாடு",
      icon: "🪔",
      price: "₹300",
      desc: "மண்டல காலத்தில் செய்யப்படும் தீப வழிபாடு.",
      image: "/assets/13.jpg"
    },
    {
      id: 26,
      name: "சுற்றுவிளக்கு",
      icon: "🪔",
      price: "₹401",
      desc: "கோயிலைச் சுற்றி விளக்குகள் ஏற்றி செய்யப்படும் வழிபாடு.",
      image: "/assets/4.jpg"
    },
    {
      id: 27,
      name: "நிரமாலை சுற்றுவிளக்கு",
      icon: "✨",
      price: "₹1000",
      desc: "அழகான விளக்குகளால் அலங்கரித்து கோயிலைச் சுற்றி செய்யப்படும் தீப வழிபாடு.",
      image: "/assets/deepaam.jpg"
    },
    {
      id: 28,
      name: "சாந்தாபிஷேகம்",
      icon: "🪔",
      price: "₹1250",
      desc: "சந்தன விழுதால் செய்யப்படும் புனித அபிஷேக வழிபாடு.",
      image: "/assets/dharshana.png"
    },
    {
      id: 29,
      name: "முழு நாள் பூஜை",
      icon: "🙏",
      price: "₹1251",
      desc: "ஒரு நாள் முழுவதும் பக்தரின் பெயரில் செய்யப்படும் பூஜை.",
      image: "/assets/17.jpg"
    }
  ],

  ML: [
    {
      id: 1,
      name: "പൂജ",
      icon: "🙏",
      price: "₹5",
      desc: "ക്ഷേത്രത്തിൽ ദൈനംദിനം നടത്തുന്ന അടിസ്ഥാന പൂജ.",
      image: "/assets/dharshana.png"
    },
    {
      id: 2,
      name: "മാല",
      icon: "🌸",
      price: "₹5",
      desc: "പൂമാല സമർപ്പിക്കൽ.",
      image: "/assets/11.jpg"
    },
    {
      id: 3,
      name: "പുഷ്പാഞ്ജലി",
      icon: "🌸",
      price: "₹8",
      desc: "പൂക്കൾ സമർപ്പിച്ച് ചെയ്യുന്ന പ്രാർത്ഥന.",
      image: "/assets/20.jpg"
    },
    {
      id: 4,
      name: "നെയ്യ് വിളക്ക്",
      icon: "🪔",
      price: "₹10",
      desc: "നെയ്യ് ഉപയോഗിച്ച് വിളക്ക് തെളിയിക്കൽ.",
      image: "/assets/16.jpg"
    },
    {
      id: 5,
      name: "മാലയിടൽ",
      icon: "🌼",
      price: "₹10",
      desc: "മാലയോടെ നടത്തുന്ന പൂജ.",
      image: "/assets/12.jpg"
    },
    {
      id: 6,
      name: "കെട്ടുനിറ",
      icon: "🎁",
      price: "₹10",
      desc: "കെട്ടി സമർപ്പിക്കുന്ന പ്രതീകാത്മക വഴിപാടു.",
      image: "/assets/9.jpg"
    },
    {
      id: 7,
      name: "രക്ത പുഷ്പാഞ്ജലി",
      icon: "🌺",
      price: "₹10",
      desc: "ചുവപ്പ് പൂക്കൾ ഉപയോഗിച്ചുള്ള പ്രത്യേക വഴിപാടു.",
      image: "/assets/21.jpg"
    },
    {
      id: 8,
      name: "കതിന (1 എണ്ണം)",
      icon: "🎆",
      price: "₹10",
      desc: "പരമ്പരാഗത പടക്ക വഴിപാടു.",
      image: "/assets/26.jpg"
    },
    {
      id: 9,
      name: "ചോറൂണ്",
      icon: "👶",
      price: "₹25",
      desc: "കുഞ്ഞിന്റെ ആദ്യ അന്നഭക്ഷണ ചടങ്ങ്.",
      image: "/assets/3.webp"
    },
    {
      id: 10,
      name: "ത്രിമധുരം",
      icon: "🍬",
      price: "₹25",
      desc: "മൂന്ന് മധുരങ്ങൾ ചേർത്ത് തയ്യാറാക്കുന്ന നൈവേദ്യം.",
      image: "/assets/23.jpg"
    },
    {
      id: 11,
      name: "പണപ്പായസം",
      icon: "🍯",
      price: "₹30",
      desc: "പനശർക്കര ഉപയോഗിച്ചുള്ള പരമ്പരാഗത പായസം.",
      image: "/assets/19.jpg"
    },
    {
      id: 12,
      name: "സൂക്ത പുഷ്പാഞ്ജലി",
      icon: "📿",
      price: "₹40",
      desc: "വേദമന്ത്രങ്ങളോടെ നടത്തുന്ന പുഷ്പാഞ്ജലി.",
      image: "/assets/22.jpg"
    },
    {
      id: 13,
      name: "തുലാഭാരം ശീട്ട്",
      icon: "⚖️",
      price: "₹50",
      desc: "ഭക്തന്റെ ഭാരം തുല്യമായ വഴിപാടിനുള്ള ടോക്കൺ ശീട്ട്.",
      image: "/assets/25.jpg"
    },
    {
      id: 14,
      name: "ആടിയചാന്ത്",
      icon: "📿",
      price: "₹50",
      desc: "ദൈവിക ശക്തിയും പോസിറ്റീവ് ഊർജവും ആഹ്വാനം ചെയ്യുന്ന പരമ്പരാഗത ജപം.",
      image: "/assets/2.jpg"
    },
    {
      id: 15,
      name: "നെയ്യ് പായസം",
      icon: "🥣",
      price: "₹50",
      desc: "നെയ്യ് ഉപയോഗിച്ച് തയ്യാറാക്കുന്ന മധുര നൈവേദ്യം.",
      image: "/assets/15.jpg"
    },
    {
      id: 16,
      name: "കൂട്ടുപായസം",
      icon: "🍮",
      price: "₹50",
      desc: "വിവിധ പായസങ്ങളുടെ മിശ്രിതം.",
      image: "/assets/10.jpg"
    },
    {
      id: 17,
      name: "തട",
      icon: "🛕",
      price: "₹60",
      desc: "ക്ഷേത്രത്തിലെ പ്രത്യേക വഴിപാടു.",
      image: "/assets/17.jpg"
    },
    {
      id: 18,
      name: "പാൽ പായസം",
      icon: "🥛",
      price: "₹60",
      desc: "പാൽയും അരിയും ചേർത്ത് തയ്യാറാക്കുന്ന പായസം.",
      image: "/assets/188.jpg"
    },
    {
      id: 19,
      name: "കടുമധുര പായസം",
      icon: "🍯",
      price: "₹70",
      desc: "ശർക്കരയും അരിയും ചേർത്ത് തയ്യാറാക്കുന്ന നൈവേദ്യം.",
      image: "/assets/8.jpg"
    },
    {
      id: 20,
      name: "ഗണപതി ഹോമം",
      icon: "🔥",
      price: "₹70",
      desc: "വിഘ്നങ്ങൾ നീക്കാൻ ഗണപതിക്കുള്ള ഹോമം.",
      image: "/assets/7.jpg"
    },
    {
      id: 21,
      name: "ഭഗവതി സേവ",
      icon: "🪔",
      price: "₹100",
      desc: "ഭഗവതി അമ്മയ്ക്ക് അനുഗ്രഹവും സംരക്ഷണവും നേടുന്നതിനുള്ള പ്രത്യേക പൂജ.",
      image: "/assets/dharshana.png"
    },
    {
      id: 22,
      name: "ദീപസ്തംഭം തെളിയിക്കൽ",
      icon: "🔥",
      price: "₹200",
      desc: "ക്ഷേത്രത്തിലെ ദീപസ്തംഭത്തിൽ വിളക്ക് തെളിയിക്കൽ.",
      image: "/assets/fire.jpg"
    },
    {
      id: 23,
      name: "ത്രികാല പൂജ",
      icon: "🛕",
      price: "₹251",
      desc: "ഒരു ദിവസം മൂന്ന് നേരം നടത്തുന്ന പൂജ.",
      image: "/assets/24.jpg"
    },
    {
      id: 24,
      name: "നവരാത്രി പൂജ വിളക്ക്",
      icon: "✨",
      price: "₹300",
      desc: "നവരാത്രി സമയത്തെ പ്രത്യേക ദീപാരാധന.",
      image: "/assets/14.jpg"
    },
    {
      id: 25,
      name: "മണ്ഡല പൂജ വിളക്ക്",
      icon: "🪔",
      price: "₹300",
      desc: "മണ്ഡല കാലത്ത് നടത്തുന്ന വിളക്ക് പൂജ.",
      image: "/assets/13.jpg"
    },
    {
      id: 26,
      name: "ചുറ്റുവിളക്ക്",
      icon: "🪔",
      price: "₹401",
      desc: "ക്ഷേത്രം ചുറ്റി വിളക്കുകൾ തെളിയിക്കുന്ന വഴിപാടു.",
      image: "/assets/4.jpg"
    },
    {
      id: 27,
      name: "നിരമാല ചുറ്റുവിളക്ക്",
      icon: "✨",
      price: "₹1000",
      desc: "വിളക്കുകൾ അലങ്കരിച്ച് ക്ഷേത്രം ചുറ്റി നടത്തുന്ന ദീപാരാധന.",
      image: "/assets/deepaam.jpg"
    },
    {
      id: 28,
      name: "ചാന്താഭിഷേകം",
      icon: "🪔",
      price: "₹1250",
      desc: "ചന്ദനം ഉപയോഗിച്ച് നടത്തുന്ന പുണ്യ അഭിഷേക ചടങ്ങ്.",
      image: "/assets/dharshana.png"
    },
    {
      id: 29,
      name: "ഒരു ദിവസത്തെ പൂജ",
      icon: "🙏",
      price: "₹1251",
      desc: "ഒരു ദിവസം മുഴുവൻ ഭക്തന്റെ പേരിൽ നടത്തുന്ന പൂജ.",
      image: "/assets/17.jpg"
    }
  ]
};

export default poojaData;